import {
  ExpandedWeddingDatesRequest,
  FlexibleWeddingDateRequest,
} from '@zola/svc-marketplace-ts-types';

import { Weekdays } from '../dates';
import { destringifyYear } from '../FlexibleDateSelection/flexibleDateSelectionHelpers';
import { formatDate } from '../WeddingDateField/dateFunctions';
import { WeddingDateFormFields, WeddingDate } from '../WeddingDateField/types';

/**
 * Converts Form Values to the fields in the Inquiry.
 */
export const buildFlexibleDatesRequest = (
  values: WeddingDateFormFields
): ExpandedWeddingDatesRequest | null => {
  const { showFlexibleDateSelection } = values;
  if (values.expandedWeddingDateFirstChoice && !showFlexibleDateSelection) {
    const {
      expandedWeddingDateFirstChoice,
      expandedWeddingDateSecondChoice,
      expandedWeddingDateThirdChoice,
    } = values;

    const requests = [
      expandedWeddingDateFirstChoice,
      expandedWeddingDateSecondChoice,
      expandedWeddingDateThirdChoice,
    ].filter((d) => d?.weddingDay && d?.weddingYear && d?.weddingMonth) as WeddingDate[];

    return {
      daysOfWeek: [],
      flexibleDates: [],
      exactDates: requests.map((date, index) => ({
        year: Number.parseInt(date.weddingYear, 10),
        month: Number.parseInt(date.weddingMonth, 10),
        day: date.weddingDay,
        preferred: index === 0,
      })),
    };
  }
  if (
    values.expandedWeddingYears &&
    values.expandedWeddingMonths &&
    values.expandedWeddingWeekdays
  ) {
    // Array of strings like key2025, key2024
    const yearKeys = values.expandedWeddingYears;

    const requests: FlexibleWeddingDateRequest[] = yearKeys.map((yearKey) => {
      // Turn key2025 into 2025
      const yearAsString = destringifyYear(yearKey);

      // array of strings, 01, 02, 09, 10 (Jan, Feb, Sept, Oct)
      const monthsForYear: string[] =
        (values.expandedWeddingMonths && values.expandedWeddingMonths[yearKey]) || [];

      return {
        year: Number.parseInt(yearAsString, 10),
        months: monthsForYear.map((m) => Number.parseInt(m, 10)),
      };
    });

    const daysOfWeek = values.expandedWeddingWeekdays
      .map((v) => {
        return Weekdays.find((weekday) => weekday.label === v)?.enum;
      })
      .filter(Boolean) as ExpandedWeddingDatesRequest.DaysOfWeekEnum[];

    return {
      daysOfWeek,
      flexibleDates: requests,
      exactDates: [],
    };
  }
  return null;
};

export const getVenueWeddingDate = (values: WeddingDateFormFields): string | null => {
  const { expandedWeddingExactDate } = values;
  if (expandedWeddingExactDate) {
    const parsedDate = new Date(expandedWeddingExactDate);

    const weddingYear = parsedDate.getFullYear();
    const weddingMonth = parsedDate.getMonth() + 1; // January is 0 according to Date, but we are expecting January to be 1
    const weddingDay = parsedDate.getDate();
    const date = formatDate(`${weddingYear}-${weddingMonth}-${weddingDay}`);

    return date;
  }

  return null;
};
